<script setup lang="ts">
import { useRoute } from 'vue-router';

const route = useRoute();

const items = [
  { label: 'Главная', icon: 'pi pi-home', to: '/app/home', hint: 'Что вообще происходит' },
  { label: 'Стена Плача', icon: 'pi pi-comments', to: '/app/wall', hint: 'Куда сливать мысли' },
  { label: 'Пользователи', icon: 'pi pi-users', to: '/app/users', hint: 'Кто тут зареган' },
  { label: 'Подарки', icon: 'pi pi-gift', to: '/app/gifts', hint: 'Кидать друг другу' },
  { label: 'Игральня', icon: 'pi pi-bolt', to: '/app/playground', hint: 'Тыкалка и лес' },
];
</script>

<template>
  <aside class="app-sidebar">
    <p class="app-sidebar__title">Навигация</p>
    <nav class="app-sidebar__nav">
      <RouterLink
        v-for="item in items"
        :key="item.to"
        :to="item.to"
        class="app-sidebar__link"
        :class="{ 'app-sidebar__link--active': route.path === item.to || route.path.startsWith(`${item.to}/`) }"
      >
        <i :class="item.icon" />
        <span>
          <strong>{{ item.label }}</strong>
          <small>{{ item.hint }}</small>
        </span>
      </RouterLink>

      <RouterLink
        to="/app/settings"
        class="app-sidebar__link"
        :class="{ 'app-sidebar__link--active': route.path === '/app/settings' }"
      >
        <i class="pi pi-cog" />
        <span>
          <strong>Настройки</strong>
          <small>Профиль и пароль</small>
        </span>
      </RouterLink>
    </nav>
  </aside>
</template>

<style scoped>
.app-sidebar {
  width: 260px;
  padding: 1.25rem;
  background: rgba(255, 255, 255, 0.72);
  border-right: 1px solid #fce7f3;
}

.app-sidebar__title {
  margin: 0 0 1rem;
  font-size: 0.8rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #db2777;
  font-weight: 700;
}

.app-sidebar__nav {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.app-sidebar__link {
  display: flex;
  gap: 0.75rem;
  align-items: flex-start;
  padding: 0.85rem 1rem;
  border-radius: 1rem;
  text-decoration: none;
  color: #831843;
  background: transparent;
}

.app-sidebar__link strong {
  display: block;
}

.app-sidebar__link small {
  color: #be185d;
}

.app-sidebar__link--active,
.app-sidebar__link:hover {
  background: #fdf2f8;
}

@media (max-width: 900px) {
  .app-sidebar {
    display: none;
  }
}
</style>
